import { useState } from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { Dialog } from "antd-mobile";
import useNavigation from "../../hooks/useNavigation";
import { useStores } from "../../models";
import { formatPrice } from "../../utils";
import { ToastError } from "../Toast";
import CreditStatus from "./CreditStatus";
import PayPasswordModal from "./PayPasswordModal";
import { payTypeImage } from "./types";

const Box = styled.div`
  padding: 15px 0;
  margin: 0 15px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Name = styled.span`
  font-weight: 700;
  font-size: 14px;
`;

const Muted = styled.span`
  font-size: 12px;
  color: #999;
`;

const Btn = styled.button<{ $danger?: boolean }>`
  width: 80px;
  height: 30px;
  border-radius: 6px;
  background: #fff;
  border: 1px solid ${({ $danger, theme }) => ($danger ? theme.colors.primary : "#33c341")};
  color: ${({ $danger, theme }) => ($danger ? theme.colors.primary : "#33c341")};
  margin-left: 8px;
  cursor: pointer;
`;

const MyOrderCard = ({
  order,
  tab,
  onRefresh,
}: {
  order: any;
  tab: number;
  onRefresh?: () => void;
}) => {
  const { navigate } = useNavigation();
  const { orderStore, walletStore } = useStores();
  const [pwdVisible, setPwdVisible] = useState(false);

  const {
    stock,
    amount,
    min_trading,
    max_trading,
    payment_methods,
    username,
    name,
    credit_score,
  } = order || {};

  const cancelOrder = () => {
    orderStore.publicPendingOrderCancel(
      order,
      () => {
        onRefresh?.();
        walletStore.getWalletInfo();
      },
      (error: any) => ToastError(error?.message || "取消失败")
    );
  };

  return (
    <Box
      onClick={() =>
        navigate("PeddingOrderDetail", {
          id: order.order_no || order.id,
        })
      }
    >
      <Row>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Name>{username || name}</Name>
          <CreditStatus credit_score={credit_score} />
        </div>
        <Muted>¥ {formatPrice(amount)} / 单价</Muted>
      </Row>
      <Row style={{ marginTop: 10 }}>
        <Muted>
          数量 {formatPrice(stock)} · 限额 {formatPrice(min_trading)}-{formatPrice(max_trading)}
        </Muted>
        <div>
          {(payment_methods || []).map((t: number, i: number) => (
            <img
              key={`${t}-${i}`}
              src={payTypeImage(t)}
              alt=""
              width={18}
              height={18}
              style={{ marginLeft: 4 }}
            />
          ))}
        </div>
      </Row>
      {tab === 1 && (
        <Row style={{ marginTop: 12, justifyContent: "flex-end" }} onClick={(e) => e.stopPropagation()}>
          <Btn
            $danger
            onClick={() => {
              Dialog.confirm({
                title: "提示",
                content: "确定要取消订单?",
                confirmText: "确定",
                cancelText: "取消",
                onConfirm: () => setPwdVisible(true),
              });
            }}
          >
            取消
          </Btn>
          <Btn
            onClick={() =>
              navigate("PeddingOrderDetail", {
                id: order.order_no || order.id,
              })
            }
          >
            详情
          </Btn>
        </Row>
      )}
      <PayPasswordModal
        visible={pwdVisible}
        setVisible={setPwdVisible}
        callBack={(ok) => ok && cancelOrder()}
      />
    </Box>
  );
};

export default observer(MyOrderCard);
